/**
 * @generated SignedSource<<b8ed35fa23788eaea0d1eb92471e7f05>>
 * @relayHash 2820a095ae7566b0d9e48bbf4b073a4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c97859d83625338169d38498096c0e05b0ed89a36118e4c759690c6b37f1e1b3

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseInputTextFormat = "ADF" | "PLAIN" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseInputText = {
  format: KnowledgeDiscoveryKeyPhraseInputTextFormat;
  text: string;
};
export type preloadAutohighlightsQuery$variables = {
  entityAri: string;
  inputText?: KnowledgeDiscoveryKeyPhraseInputText | null;
  jiraAssigneeAccountId?: string | null;
  jiraReporterAccountId?: string | null;
  workspaceId: string;
};
export type preloadAutohighlightsQuery$data = {
  readonly autohighlightsQueryFragment: {
    readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
  };
  readonly knowledgeDiscovery: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null> | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type preloadAutohighlightsQuery = {
  response: preloadAutohighlightsQuery$data;
  variables: preloadAutohighlightsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inputText"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraAssigneeAccountId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraReporterAccountId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "entityAri"
  },
  {
    "kind": "Variable",
    "name": "inputText",
    "variableName": "inputText"
  },
  {
    "kind": "Variable",
    "name": "jiraAssigneeAccountId",
    "variableName": "jiraAssigneeAccountId"
  },
  {
    "kind": "Variable",
    "name": "jiraReporterAccountId",
    "variableName": "jiraReporterAccountId"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v6 = {
  "concreteType": "KnowledgeDiscoveryQueryApi",
  "kind": "LinkedField",
  "name": "knowledgeDiscovery",
  "plural": false,
  "selections": [
    {
      "args": (v5/*: any*/),
      "kind": "LinkedField",
      "name": "keyPhrases",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "KnowledgeDiscoveryKeyPhrase",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "keyPhrase"
                },
                {
                  "kind": "ScalarField",
                  "name": "category"
                }
              ]
            }
          ],
          "type": "KnowledgeDiscoveryKeyPhraseConnection"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ],
          "type": "QueryError"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadAutohighlightsQuery",
    "selections": [
      (v6/*: any*/),
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "preloadAutohighlightsQuery_query"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "autohighlightsQueryFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadAutohighlightsQuery",
    "selections": [
      (v6/*: any*/)
    ]
  },
  "params": {
    "cacheID": "2820a095ae7566b0d9e48bbf4b073a4b",
    "id": "c97859d83625338169d38498096c0e05b0ed89a36118e4c759690c6b37f1e1b3",
    "metadata": {},
    "name": "preloadAutohighlightsQuery",
    "operationKind": "query",
    "text": "query preloadAutohighlightsQuery($entityAri:String!,$workspaceId:String!,$jiraReporterAccountId:String,$jiraAssigneeAccountId:String,$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}},...preloadAutohighlightsQuery_query_3JqkOF}fragment preloadAutohighlightsQuery_query_3JqkOF on Query{knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
  }
};
})();

(node as any).hash = "dbfa17d85f2c22cbfd96f030d30cc29a";

export default node;
